<script setup lang="ts">
import {Avatar, Button, Icon} from "@/Components/Library";
import Str from "@/Utils/Str";

const {group, showMenu = true} = defineProps<{
    group: {
        id: number;
        name: string;
        color: string;
        initials: string;
        is_owner: boolean;
        is_admin: boolean;
        can_admin: boolean;
        is_creator: boolean;
        anonymization: string;
    };
    showMenu?: boolean;
}>();

// console.log("group item", props.group);
const emit = defineEmits(["toggleGroupMenu"]);
</script>
<template>
    <div class="items--center flex text-sm">
        <div class="flex grow items-start gap-2 py-4 pl-3" v-bind="$attrs">
            <Avatar
                class="flex h-10 w-10 shrink-0 text-lg"
                :class="[`bg-${group.color?.class}`, group.color?.class === 'white' ? 'text-black' : 'text-white']"
                :label="group.icon ? undefined : group.initials"
                :image="group.icon?.url"
            />
            <div class="flex flex-col justify-start">
                <div>
                    <p class="mb-1.5 mt-1 font-semibold leading-none">{{ group.name }}</p>
                    <p v-if="group.user" class="mb-2 flex items-center gap-1 text-xs">
                        <Icon icon="mdi:shield-account" width="16" />
                        {{ group.user.name }}
                    </p>
                    <div class="mb-1.5 flex items-center gap-2">
                        <div class="flex w-8 items-end gap-1">
                            <Icon icon="mage:message-question-mark-round-fill" width="16" />
                            <span class="text-xs">{{ group.questions_count }}</span>
                        </div>
                        <div
                            v-if="group.anonymization.slug !== 'invisible' || group.is_owner"
                            class="flex w-8 items-end gap-1"
                        >
                            <Icon icon="mdi:account-group" width="16" />
                            <span class="text-xs">{{ group.members_count }}</span>
                        </div>
                        <p class="flex items-center gap-1 text-xs">
                            <Icon icon="heroicons:eye-solid" width="16" />
                            <span>{{ group.anonymization.name }}</span>
                        </p>
                        <!-- Tried to find icons that would represent anonymization, but IMO it's unintuitive -->
                        <!--                    <Icon-->
                        <!--                        :icon="-->
                        <!--                            {-->
                        <!--                                full_name: 'mdi:account-details',-->
                        <!--                                nickname: 'mdi:account-circle',-->
                        <!--                                initials_only: 'mdi:account-box',-->
                        <!--                                fully_anonymous: 'mdi:incognito',-->
                        <!--                                invisible: 'mdi:eye-off',-->
                        <!--                            }[group.anonymization.slug]-->
                        <!--                        "-->
                        <!--                        width="16"-->
                        <!--                    />-->
                    </div>
                    <p class="text-xs">{{ Str.of(group.description).truncate().toString() }}</p>
                </div>
            </div>
            <div class="ml-auto flex h-full items-center px-2 text-stone-500">
                <Icon
                    v-if="group.params.allow_member_posts"
                    icon="material-symbols-light:post-add-rounded"
                    width="18"
                    class="mr-2"
                />
                <Icon v-if="group.is_owner" icon="mdi:shield-account" width="18" />
                <Icon v-if="group.is_admin" icon="la:user-tie" width="18" />
                <Icon v-if="group.is_creator" icon="mingcute:user-edit-line" width="18" />
            </div>
        </div>
        <Button
            v-if="showMenu"
            :icon="{
                icon: 'pepicons-pencil:dots-y',
                width: '24',
            }"
            @click.stop.prevent="emit('toggleGroupMenu', group)"
            class="!pr-3 !ring-0"
        />
    </div>
</template>
<style scoped></style>
